module.exports = __webpack_public_path__ + "img/Flag_of_Japan.8608025c.svg";